import { PlanType } from '@/enums';

export const getPlanTypeName = (value: number): string | undefined => {
    const keys = Object.keys(PlanType).filter(key => isNaN(Number(key))); // Filter out numeric keys
    const key = keys.find(key => PlanType[key as keyof typeof PlanType] === value);
    return key as string | undefined;
};